import classNames from "classnames";
import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";
import { IconButton } from "./IconButton";

export interface HandleIconProps {
  dragEventListeners?: {
    onDragStart: (event: React.DragEvent<HTMLElement>) => void;
    onDragEnd: (event: React.DragEvent<HTMLElement>) => void;
  };
  icon: IconType;
}

export const HandleIcon = ({ icon, dragEventListeners }: HandleIconProps) => {
  const isDraggable = Boolean(dragEventListeners);

  return (
    <span className="flex">
      <Icon
        className={classNames("flex", {
          "group-hover:hidden": isDraggable,
        })}
        type={icon}
        size={16}
        useWithFillCurrentColor
      />
      {isDraggable && (
        <IconButton
          className="hidden cursor-move group-hover:flex"
          {...dragEventListeners}
        >
          <Icon type="16-drag-handle" size={16} />
        </IconButton>
      )}
    </span>
  );
};
